import Vue from 'vue';

Vue.filter('formatPrice', (value) => {
  if (!value) return '';
  return `${new Intl.NumberFormat().format(value)} ₽`;
});
